exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".titleBannerBienvenida{\n    font-size: 25px;    \n}\n\n@media \nonly screen and (max-width: 768px) {\n\n      #img1{\n          background-image: url(" + require("../../../assets/images/prueba.png") + ") !important;\n      }\n\n      \n}\n\n@media \nonly screen and (max-width: 475px) {\n    .titleBannerBienvenida{\n        font-size: 15px;        \n    }  \n      \n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/office/home/home.component.css
// module id = ../../../../../src/app/office/home/home.component.css
// module chunks = main